import React, { Component } from 'react';
import { connect } from 'react-redux';
import './_styles.scss';
import ConfigMenuButton from '../../components/ConfigMenuButton/ConfigMenuButton';
import { getButtons } from './configButtons';

class Config extends Component {

    state = {
        focusedButton: null
    };
    buttonsContainer = null;
    focusTimeout = null;
    propsToButton = {
        avatarImages: this.props.profile && this.props.profile.members && this.props.profile.members.map((member) => member.user_image)
    };

    componentDidMount() {
        this.setFirstButtonFocus();
    }

    componentWillUnmount() {
        if (this.focusTimeout) {
            clearTimeout(this.focusTimeout);
        }
    }

    setButtonsContainerRef = (element) => {
        this.buttonsContainer = element;
    }

    handleButtonFocus = (button) => {
        this.setState({ focusedButton: button });
    }

    setFirstButtonFocus = () => {
        if (this.buttonsContainer) {
            this.focusTimeout = setTimeout(() => {
                const firstFocusable = this.buttonsContainer.querySelector('.focusable');
                if (firstFocusable) {
                    firstFocusable.focus();
                }
            }, 0);
        }
    }

    render() {
        const buttons = getButtons({
            profile: this.props.profile,
            user: this.props.user
        });
        const { focusedButton } = this.state;

        return (
        <div className="config-container">

            <div className="left-column">
                {focusedButton && focusedButton.img && focusedButton.img(this.propsToButton)}
            </div>

            <div className="right-column">
                <div
                    className="buttons-container"
                    ref={this.setButtonsContainerRef}
                >
                    {buttons.map((button) => (
                        <ConfigMenuButton
                            key={button.id}
                            labelKey={button.labelKey}
                            onClick={button.onClick}
                            onFocus={() => this.handleButtonFocus(button)}
                        />
                    ))}
                </div>
            </div>
        </div>
        );
    }

}

const mapStateToProps = ({ profile, user }) => ({ profile, user });

export default connect(mapStateToProps)(Config);


// WEBPACK FOOTER //
// ./src/containers/config/Config.jsx